import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadFile } from '../_models/upload_files';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(private http : HttpClient) { }

  getFilesForUpload(uploadid:number): Observable<UploadFile[]> {
    return this.http.get<UploadFile[]>(environment.apiUrl + `/uploads/${uploadid}/files`);
  }
}
